import { loadable } from 'utils';

export const ChargeDetailsCard = loadable(() => import('./ChargeDetailsCard'), {});
export const SummaryDetailsCard = loadable(() => import('./SummaryDetailsCard'), {});
export const OrderDetailsCard = loadable(() => import('./OrderDetailsCard'), {});
export const TransactionDetailsCard = loadable(() => import('./TransactionDetailsCard'), {});
export const GatewayDetailsCard = loadable(() => import('./GatewayDetailsCard'), {});
